export default __webpack_public_path__ + "../staticImages/sprite-milesmore-2x.png";